export default __webpack_public_path__ + "static/media/profile1.6c82fa7c.png";